export enum DropZone
{
    TABLE = 'table',
    HAND = 'hand'
}
